function NumberToWord({ number }) {
  const words = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  const convertToWords = (num) => {
    const n = Math.floor(Math.abs(Number(num)));
    if (n === 0) return "";
    if (n < 20) return words[n] + " ";
    if (n < 100) return tens[Math.floor(n / 10)] + " " + convertToWords(n % 10);
    return (
      words[Math.floor(n / 100)] + " Hundred " + convertToWords(n % 100)
    );
  };

  const formatNumber = (num) => num.toString().split(",").join("");

  /** Integer rupees only (Indian grouping). */
  const convertToIndianWords = (num) => {
    if (num === 0) return "";
    const formattedNum = Number(formatNumber(String(num)));
    if (!Number.isFinite(formattedNum) || formattedNum < 0) return "";
    const n = Math.floor(formattedNum);
    const crores = Math.floor(n / 10000000);
    const lakhs = Math.floor((n % 10000000) / 100000);
    const thousands = Math.floor((n % 100000) / 1000);
    const remainder = n % 1000;

    let words_string = "";
    if (crores) words_string += convertToWords(crores) + " Crores ";
    if (lakhs) words_string += convertToWords(lakhs) + " Lakhs ";
    if (thousands) words_string += convertToWords(thousands) + " Thousand ";
    if (remainder) words_string += convertToWords(remainder);

    return words_string.trim();
  };

  const raw = String(number ?? "")
    .replace(/,/g, "")
    .trim();
  const parsed = Number(raw);
  if (!Number.isFinite(parsed)) return "";

  const totalPaise = Math.round(Math.max(0, parsed) * 100);
  const rupees = Math.floor(totalPaise / 100);
  const paise = totalPaise % 100;

  if (rupees === 0 && paise === 0) return "Zero Rupees Only";

  const rupeeWords = convertToIndianWords(rupees);
  if (paise > 0) {
    const p = convertToWords(paise).trim();
    return (
      (rupeeWords ? `${rupeeWords} Rupees and ` : "") +
      p +
      " Paise Only"
    );
  }
  return `${rupeeWords} Rupees Only`;
}

export default NumberToWord;
